import { create } from 'zustand'

interface ArchiveState {
  /** Folder is connected and readwrite permission is currently granted. */
  ready: boolean
  /** Name of the connected directory (display only). */
  folderName: string | null
  /** Permission needs a one-click re-grant this session. */
  needsPermission: boolean
  running: boolean
  phase: string | null
  lastRunAt: number | null
  /** Files written over the archiver's lifetime (from kv counters). */
  totalArchived: number
  /** Cache entries dropped in the last run after on-disk verification. */
  evicted: number
  error: string | null

  set: (p: Partial<Omit<ArchiveState, 'set'>>) => void
}

export const useArchive = create<ArchiveState>((set) => ({
  ready: false,
  folderName: null,
  needsPermission: false,
  running: false,
  phase: null,
  lastRunAt: null,
  totalArchived: 0,
  evicted: 0,
  error: null,
  set: (p) => set(p),
}))
